import { Search } from "lucide-react";

interface EmptyStateProps {
  body: string;
  title: string;
}

export function EmptyState({ body, title }: EmptyStateProps) {
  return (
    <div className="flex h-full min-h-[240px] w-full flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#f6f6f6] text-[#8c929c]">
        <Search aria-hidden="true" className="h-6 w-6" />
      </span>
      <h3 className="text-lg font-semibold leading-7 text-[#0a0c11]">{title}</h3>
      <p className="max-w-[280px] text-sm leading-5 text-[#5b616d]">{body}</p>
    </div>
  );
}
